class CartNote extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController()
    this.noteInput = this.querySelector('[name="note"]')
    this.noteBtn = this.querySelector('.add-note')
    this.cartNoteContainer = this.querySelector('.cart__note')

    // Defensive checks for existence before adding listeners
    if (this.noteInput) {
      this.noteInput.addEventListener(
        'change',
        (evt) => {
          const newNote = evt.target.value
          this.updateNote(newNote)
        },
        { signal: this.abortController.signal }
      )
    }

    if (this.noteBtn && this.cartNoteContainer) {
      this.noteBtn.addEventListener(
        'click',
        () => {
          this.noteBtn.classList.toggle('is-active')
          this.cartNoteContainer.classList.toggle('hide')
        },
        { signal: this.abortController.signal }
      )
    }
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  async updateNote(note) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          note: note
        })
      })
      if (!response.ok) throw response
      return await response.json()
    } catch (err) {
      alert('There was a problem updating your note. Please try again.')
      // Optional: visually indicate error or reset field if you wish
    }
  }
}

customElements.define('cart-note', CartNote)
